import React, {Component} from 'react'
import './RecordSearchArea.css'


class RecordSearchArea extends Component {
    constructor(props) {
        super(props)
        this.state = {
           basicSearchWord:"查詢全欄位，可用 AND、OR 布林邏輯",
           advanceSearchWord:null,
           showAdvancedSearchArea:false,
           showAutofillList:false,
           selectedAutofillList:0

           
        }
    }

    componentDidMount(){
        
    }

    



    render(){
        let inputTextDefaultStyle = {
            display: "inline-block",
            width:"300px",
            height:"30px",
            fontSize: "15px",
            fontFamily:"Microsoft JhengHei",
            border: "1px solid #adb4bf",
            borderRadius: "4px 0px 0px 4px",  
            backgroundColor:"#ffffff",
            color: "#adb4bf"
        }

        let inputTextStyle = {
            display: "inline-block",
            width:"300px",
            height:"30px",
            fontSize: "15px",
            fontFamily:"Microsoft JhengHei",
            border: "1px solid #adb4bf",
            borderRadius: "4px 0px 0px 4px",  
            backgroundColor:"#ffffff",
            color: "#adb4bf"
        }

        return(
            <div className="SearchAreaDemo">
                <div className="basicSearchArea">
                    <div style={{display:"flex"}}>
                        <div>
                            <input style={this.state.basicSearchWord === "查詢全欄位，可用 AND、OR 布林邏輯" ? inputTextDefaultStyle:inputTextStyle} type="text" value={this.state.basicSearchWord ? this.state.basicSearchWord : "" }  />
                        </div>
                        <div className="advanceSearchAreaSubmitButton">查詢</div>         
                    </div>
                    <div className="ToggleAdvanceAreaButton">{!this.state.showAdvancedSearchArea? "開啟進階查詢 +":"收合進階查詢 -"}</div>
                </div>
            </div>    
        )
    }
}

export default RecordSearchArea
